import owd from 'owd/owd';

export default class NavToggle extends owd.Component {
	init() {
		this.cssClass = 'menu-visible';
		this.isEnabled = true;
		this.onPageOut = this.onPageOut.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onOuterClick = this.onOuterClick.bind(this);
		this.onNavHide = this.onNavHide.bind(this);
		this.bind();

		if (this.$element.data('nav-toggle') !== undefined) {
			this.cssClass = this.$element.data('nav-toggle');
		}
	}

	bind() {
		this.on('click', this.onClick);
		this.on('click', $('body'), this.onOuterClick);
		this.on('navHide', this.dom.$window, this.onNavHide);
		// this.on('pageOut', this.dom.$window, this.onPageOut);
	}

	show() {
		this.app.dom.$body.removeClass(this.cssClass + '-hide-anim');
		if (this.hideTimeout) {
			clearTimeout(this.hideTimeout);
			this.hideTimeout = null;
		}
		this.app.dom.$body.addClass(this.cssClass + '-visible');
		$("html, body").addClass("modal-open");
        this.$element.attr('aria-expanded', 'true');
	}

	isOpen() {
		return this.app.dom.$body.hasClass(this.cssClass + '-visible');
	}

	hide(immediately) {
		if (immediately === true) {
			this.app.dom.$body.addClass(this.cssClass + '-hide-immediately');
			this.app.dom.$body.removeClass(this.cssClass + '-visible');
			setTimeout(() => {
				this.app.dom.$body.removeClass(this.cssClass + '-hide-immediately');
			}, 100);
		} else {
			this.app.dom.$body.addClass(this.cssClass + '-hide-anim');
			this.hideTimeout = setTimeout(() => {
				this.hideTimeout = null;
				this.app.dom.$body.removeClass(this.cssClass + '-hide-anim');
			}, 800);
			this.app.dom.$body.removeClass(this.cssClass + '-visible');
		}
		$("html, body").removeClass("modal-open");
        this.$element.attr('aria-expanded', 'false');
	}

	onNavHide(e) {
		this.hide();
	}

	onClick(e) {
		e.preventDefault();
		e.stopPropagation();

		if (this.isOpen()) {
			this.hide();
		} else {
			this.show();
		}
	}

	onOuterClick(e) {
		if (this.isOpen() && !$(e.target).is('.' + this.cssClass) && !$(e.target).parents('.' + this.cssClass).length) {
			// e.preventDefault();
			this.hide();
		}
	}

	onPageOut(e) {
		setTimeout(() => {
			this.hide(true);
		}, 1000);
	}

	destroy() {
		super.destroy();
	}
}

owd.registerComponent('nav-toggle', {
	component: NavToggle
});
